(function () {
	angular
		.module('trackeye')
		.controller('ModalController', ModalController);

	ModalController.$inject = ["$state", 'ModalService', 'config'];

	function ModalController($state, ModalService, config) {
		var events = [],
			vm = this;

		vm.brand = config.defaults;
		vm.isActive = false;
		vm.state = $state.params;

		vm.openModal = function () {
			vm.isActive = true;
		};

		vm.closeModal = function () {
			// Go to parent state
			$state.go('^');
		};

		vm.emit = function(type, data) {
			ModalService.emit(type, data);
		};
	}
})();